import styled from 'styled-components';


const FooterWrapper = styled.div`
footer {
    color: #4c565c;
    width: 100%;
    bottom: 0;
    // position: absolute;
    .wrapper {
      background: #e5e8ed;
      padding: 0.5rem;

      display: flex;
      align-items: center;
      justify-content: space-between;
      .item {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        p {
          margin: 0;
          font-weight: 700;
        }
      }
      .policies a {
        color: #4c565c;
        // &:last-child {
        //   padding-left: 0.75rem;
        //   border-left: 2px solid #4c565c;
        //   margin-left: 1rem;
        // }
      }
  
      .payments img {
        height: 15px;
        margin: 0 0.5rem;
        &:hover, &:focus {
          transform: scale(1.1);
        }
      }
  
      .socials {
        a {
          &:hover, &:focus {
            transform: rotate(15deg) scale(1.1);
          }
        }
        img {
          height: 25px;
          margin: 0 0.2rem;
        }
      }
    }
  }
  
  footer.ar{
    font-family: "GESS", Verdana, Geneva, Tahoma, sans-serif;
    .wrapper {
      .policies a {
        color: #4c565c;
      }
    }
  }
  
  @media only screen and (max-width: 768px) {
    footer {
      .wrapper {
        flex-direction: column-reverse;
        text-align: center;
      }
      .item {
        margin: 0.5rem 0;
      }
    }
  }
  
  // @media only screen and (max-width: 768px) and (min-width: 576px){
  //   footer {
  //     position: absolute;
  //   }
  // }
  

`;


export default FooterWrapper;